<template>
    <v-card @click="$inertia.visit(`/meets/${meet.slug}`)">
        <div v-if="verticalLayout" class="text-center">
            <v-avatar v-if="meet.logo" class="ma-3" size="125" tile>
                <meet-logo :path="meet.logo" />
            </v-avatar>

            <v-divider />
        </div>

        <div class="d-flex flex-no-wrap justify-space-between">
            <div>
                <v-card-title class="text-h5" style="word-break: break-word">
                    {{ meet.title }}
                </v-card-title>
                <v-card-subtitle>
                    <template v-if="meet.is_a_one_day_meet">
                        <datetime-display :datetime="meet.starts_at" :timezone="meet.timezone" format="ddd, MMM Do" />
                    </template>
                    <template v-else>
                        <datetime-display :datetime="meet.starts_at" :timezone="meet.timezone" format="ddd, MMM Do" />
                        -
                        <datetime-display :datetime="meet.ends_at" :timezone="meet.timezone" format="ddd, MMM Do" />
                    </template>

                    <p>{{ meet.location }}</p>
                    <v-chip v-if="meet.is_live" class="mt-0" color="red lighten-1" dark small> Live </v-chip>
                    <v-chip
                        v-else-if="$moment.utc().isBefore($moment.utc(meet.start_date))"
                        class="mt-0"
                        color="blue lighten-1"
                        dark
                        small
                    >
                        Upcoming
                    </v-chip>

                    <v-chip v-if="meet.is_free_to_access" class="mt-0 ml-2" color="green lighten-1" dark small>
                        Free
                    </v-chip>
                </v-card-subtitle>
            </div>
            <v-avatar v-if="!verticalLayout && meet.logo" class="ma-3" size="125" tile>
                <meet-logo :path="meet.logo" />
            </v-avatar>
        </div>
    </v-card>
</template>

<script>
import MeetLogo from '@/Components/MeetLogo.vue';
import DatetimeDisplay from '@/Components/DatetimeDisplay.vue';

export default {
    components: { DatetimeDisplay, MeetLogo },

    props: {
        meet: {
            type: Object,
            required: true,
        },

        verticalLayout: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
